export default __webpack_public_path__ + "static/media/infoCircle.1c0801a0.svg";